/**
 * Remove Connection
 */
export const RemoveConnection = (function () {

    /**
     * Removes the connection from a users PDS, appears as a Bootstrap Modal
     */

    var init = function () {
        addEventListeners();
    }

    /**
     * EVENT LISTENER FUNCTIONS
     */
    function addEventListeners() {
        $('.remove-connection').on('click', function (event) {
            event.preventDefault();

            // Get the connection ID, remove it and redirect to the permissions page
            var connectionId = Util.getPathParameterByName('connections');

            var promise = removeConnection(connectionId);
            promise.then(function () {
              window.location.href = '/maa/connections';
            });
            promise.fail(function (response) {
              var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
              Util.toggleAlert('.alert', message, 'alert-warning');
            });
        })
    }

    /**
    * Ajax POST request which calls the remove connection endpoint
    */
    function removeConnection(connection_id) {

        var csrf = Util.getCSRF();
        return $.ajax({
            url: '/maa/connections/' + connection_id + '/remove',
            data: {
                con_id: connection_id
            },
            type: 'post',
            headers: {
                'x-csrf-token': csrf
            },
        });
    }

    return {
        init: init
    }

}());